import React from 'react'
import styled from 'styled-components';
import { ReactComponent as WhiteLogo } from 'assets/icons/main/whiteLogo.svg'

const Header = styled.header`
  padding: 0 26px;
  background-color:#000;
  position:fixed;
  top:0;
  width:100%;
  z-index:5;
`
const Wrapper = styled.div`
  height: 64px;
  display:flex;
  align-items:center;
  border-bottom: 1px solid #e9e9e91a;
`
const Login = styled.div`
  padding: 9px 16px;
  margin-left:auto;
  border-radius: 100px;
  background-color: #333;
  color: #eee;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
`
const LogoWrapper = styled.div`
  cursor: pointer;
`
const Burger = styled.div`
  z-index: 7;
  display: relative;
  font-size: 1.2em;
  cursor: pointer;
  margin-left:15px;
  > span{
  display: block;
  width: 30px;
  height: 2px;
  background: #eee;
  margin-bottom: 5px;
  transition: all ease-in 0.3s;
  }

  > span:nth-child(1) {
  transform: ${({ sideOpen }) => sideOpen ? 'rotate(45deg) translateY(10px)' : null}
}
  > span:nth-child(2) {
    transform: ${({ sideOpen }) => sideOpen ? { opacity: 0, width: 0 } : null}
}
  > span:nth-child(3) {
    transform: ${({ sideOpen }) => sideOpen ? 'rotate(-45deg) translateY(-10px)' : null}
}
  
`
function MainHeader({ onSignInClick, setSideOpen, sideOpen }) {

  const handleLogin = (e) => {
    onSignInClick(e)
  }
  const handleRefresh = () => {
    window.location.reload()
  }
  const handleSideMenu = () => {
    setSideOpen(() => !sideOpen)
  }
  return (
    <Header>
      <Wrapper>
        <LogoWrapper onClick={handleRefresh}>
          <WhiteLogo width={100} height={64} fill='white' />
        </LogoWrapper>
        <Login onClick={handleLogin}>로그인</Login>
        <Burger
          sideOpen={sideOpen}
          onClick={handleSideMenu}>
          <span></span>
          <span></span>
          <span></span>
        </Burger>
      </Wrapper>
    </Header>
  );
}

export default MainHeader;